console.log("init Proteus Treatments - 0.29");

// support for pre-auth
// Function to parse URL parameters
if(getParam("pre_auth")){

  const params = new URLSearchParams(window.location.search);
  
  // Create an object with the parameters
  const pre_auth_data = {
    code: params.get("code") || "",
    kit: params.get("kit") || "",
    sku: params.get("sku") || ""  
  };

  window.sessionStorage.setItem("Woobles // Shortcake pre-auth", JSON.stringify(pre_auth_data));
  
}

if(window.location.pathname == "/" && 
window.sessionStorage.getItem("Woobles // Shortcake pre-auth") && 
!window.sessionStorage.getItem("Woobles // pre-auth redirected")){
  // if on HP AND has pre-auth AND never redirected, do it once
  window.location.href = "/account";
  window.sessionStorage.setItem("Woobles // pre-auth redirected", true)
}

// support for account setup

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

if(getParam("customer_setup") == "kit"){
  
  let email = getParam("email");
  let sku = getParam("sku");
  
  if(typeof(window.skus[sku]) == "undefined"){
    console.error("This SKU was not found:" + sku)
  } else {
    
    fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=exists&email=${email}`)
    .then(response => response.json())
    .then(async (data) => {
      console.log(data.message);
      if (data.message.indexOf(": true") > -1) {
        // Add tags to existing customer
        await fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=add_tag&email=${email}&tag=my woobles: ${window.skus[sku]}`);
      } else {
        // Create customer and then add tags
        console.log("WOOBLES ACCOUNTS: customer does not exist, adding account... ", email, sku)
        try {
          await fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=create&email=${email}`);
          // Wait for 5s to ensure the customer is available
          
          await delay(5000);
          await fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=send_invite&email=${email}`);

          await delay(5000);
          await fetch(`https://proteus-app-wbls-r3.fly.dev/api/customer?action=add_tag&email=${email}&tag=my woobles: ${window.skus[sku]}`);
        } catch (error) {
          console.error("Error during customer creation:", error);
        }
      }
    }).catch(error => console.error("Error during customer existence check:", error));

  }
}

// logic to establish distinction between v0 and unspecified
window.shipping_variation = "unspecified";

if(getParam("mystery")){
  add_to_cart(44416648118438);
}

// [WBLS-59] Contextual Shop All -- 0.01
(() => { 

  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style id="contextual-collection-styles">
      .template-contextual-collection[data-contextual-view="default"] #MainContent > .main-collection {
        display: none;
      }
      
      .template-contextual-collection[data-contextual-view="grid"] #MainContent > .main-collection,
      .template-contextual-collection[data-contextual-view="grid"] #MainContent > .main-collection .section-header {
        display: block;
      }
        
      .template-contextual-collection[data-contextual-view="grid"] #MainContent > .main-collection {
        border-top: none;
        margin-top: 0;
        padding-top: 0;
      }
        
      .template-contextual-collection[data-contextual-view="grid"] #MainContent > .index-section {
        display: none;
      }
    </style>
    `);
  }).catch();    

  // preserve existing v1 bucketed users -- v0 for new users
  var wbls59_cookie_name = "[WBLS-59] // 0.01";
  var wbls59_exp_var = window.localStorage.getItem(wbls59_cookie_name) || gtm_getCookie(wbls59_cookie_name) || "v0";

  var view_preference = window.localStorage.getItem("contextual_template_default_view");
  // preserve adjusted view preferences
  if(!window.localStorage.getItem("contextual_template_default_view")){
    let default_view = wbls59_exp_var == "v0" ? "grid" : "default";
    window.localStorage.setItem("contextual_template_default_view", default_view);
    view_preference = default_view;
  } 

  if (window.location.pathname == "/collections/crochet-amigurumi-kits") {
    waitForElement('body').then(doc => {
      doc.setAttribute('data-contextual-view', view_preference);
    }).catch();
  }
  
})(); // [WBLS-59] Contextual Shop All -- 0.01


/*
[WBLS-GLOBAL] spot-fixes
*/

if(window.location.href.indexOf("/account") > -1){
  observeSelector('.form-message--error', form_error => {
    if(form_error.innerText.indexOf("This email address is already associated with an account.") > -1){
      form_error.innerHTML = `
        Looks like this email already has an account. If this account is yours, you can <a href="/account/login#recover">reset your password</a>
      `;
    }
  })

  observeSelector('.form-message--success', form_success => {
    if(form_success.innerText.indexOf("We've sent you an email with a link to update your password.") > -1){
      form_success.innerHTML = `
        Your request has been processed. If an account with this email address exists, a link will be sent to update your password.
      `;
    }
  })
}

if(window.location.href.indexOf("gift=mystery") > -1){
  add_to_cart(44416648118438, 1, {"promo": "20% off"})
}

// Klaviyo tracking
window.addEventListener("klaviyoForms", function(e) { 
  if(e.detail.type == "open" || e.detail.type == "submit"){
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': `klaviyo ${e.detail.formId} - form ${e.detail.type}`,
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });
  }
});

// metrics for sold out PDP
if(window.location.href.indexOf("/products/") > -1){
  observeSelector('.product-single .price--sold-out .price__badge--sold-out', () => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'proteus_custom_event',
      'proteus_event_name': "PDP - Sold Out",
      'proteus_event_category': "CRO",
      'page_location': window.location.href
    });
  })
}

if(window.location.href.indexOf("/collections/peanuts-collection") > -1){
  observeSelector('.product-single__meta .product-form__controls-group select', wrong_select => {
    wrong_select.classList.add("js-wrong-select");
    wrong_select.style = "display: none !important;";
  });
  
  observeSelector('.product-single__meta select[name="id"]', actual_select => {
    actual_select.classList.add("js-actual-select");
    actual_select.style = "display: block; margin-bottom: 1rem; width: 100%;";
  });
}

if(getParam("utm_campaign").indexOf("Abandoned") > -1  && getParam("proteus") == "ab-v3"){
  window.sessionStorage.setItem("WBLS-31", "v3");
  waitUntil(() => {
    return typeof $ != 'undefined';
  }).then(() => {
    cart_add_item(40331927519398, 1, () => {
      SLIDECART_UPDATE();
    });
  }).catch();
}

// on /cart page

if(window.location.href.indexOf(".com/en-") > -1){
  observeSelector('[class*="price__"] span.price-item, [class*="price__"] s.price-item', price_label => {
    price_label.innerText = price_label.innerText.replace(".00", "").replace(".00", "");
  });
}

if(window.location.href.indexOf("/collections/") > -1 && window.innerWidth <= 768 && getParam("qa") == "reviews"){
  observeSelector('.product-card .jdgm-widget', reviews => {
    let reviews_count = reviews.querySelector('.jdgm-prev-badge').getAttribute("data-number-of-reviews");
    let reviews_score = reviews.querySelector('.jdgm-prev-badge').getAttribute("data-average-rating");
    if(parseInt(reviews_count) > 0){
      reviews.querySelector('.jdgm-prev-badge').insertAdjacentHTML("beforebegin", `
        ${reviews_score} <span class="jdgm-star jdgm--on"></span>
        <div style="display: block; font-size: 9px;">${reviews_count} reviews</div>
      `); 
    }
    reviews.querySelector('.jdgm-prev-badge').classList.add("js-hidden");
  });
}

// REPLACE THE GIFT ICON IN AMP SLIDE CART
function replaceGiftTierIcon(cart) {
  if (!cart) return;

  // Find all reward tiers in the labels section
  const tierContainers = cart.querySelectorAll(
    '[data-testid="TieredRewardsProgressBar"] .rewards-tiers-labels .rewards-tiers-container'
  );

  // We expect at least 2 containers: [0] = $50 shipping, [1] = $100 gift
  if (!tierContainers || tierContainers.length < 2) return;

  const giftTierContainer = tierContainers[1]; // second tier = $100 gift
  if (!giftTierContainer) return;

  const giftIconWrapper = giftTierContainer.querySelector('.rewards-tiers-item-icon');
  if (!giftIconWrapper) return;

  giftIconWrapper.innerHTML = `
    <div class="reward-icon locked" id="icon-gift">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M16.875 5.62501H14.1344C14.1648 5.59923 14.1961 5.57423 14.2258 5.54688C14.4631 5.33608 14.6543 5.07859 14.7875 4.79052C14.9207 4.50244 14.9931 4.18998 15 3.87266C15.0103 3.52553 14.9495 3.17997 14.8213 2.85718C14.6932 2.5344 14.5005 2.24121 14.255 1.99561C14.0094 1.75 13.7163 1.55718 13.3936 1.42896C13.0708 1.30075 12.7253 1.23985 12.3781 1.25001C12.0607 1.25684 11.7481 1.32914 11.4598 1.46236C11.1716 1.59558 10.914 1.78686 10.7031 2.02423C10.4113 2.36242 10.1741 2.7441 10 3.15548C9.82592 2.7441 9.58869 2.36242 9.29688 2.02423C9.08599 1.78686 8.82837 1.59558 8.54015 1.46236C8.25193 1.32914 7.93932 1.25684 7.62187 1.25001C7.27474 1.23985 6.9292 1.30075 6.60645 1.42896C6.2837 1.55718 5.99057 1.75 5.74504 1.99561C5.49951 2.24121 5.30677 2.5344 5.17865 2.85718C5.05053 3.17997 4.98974 3.52553 5 3.87266C5.00694 4.18998 5.07929 4.50244 5.2125 4.79052C5.34572 5.07859 5.53695 5.33608 5.77422 5.54688C5.80391 5.57266 5.83516 5.59766 5.86563 5.62501H3.125C2.79348 5.62501 2.47554 5.7567 2.24112 5.99112C2.0067 6.22554 1.875 6.54349 1.875 6.87501V9.37501C1.875 9.70653 2.0067 10.0245 2.24112 10.2589C2.47554 10.4933 2.79348 10.625 3.125 10.625V15.625C3.125 15.9565 3.2567 16.2745 3.49112 16.5089C3.72554 16.7433 4.04348 16.875 4.375 16.875H9.0625C9.14538 16.875 9.22487 16.8421 9.28347 16.7835C9.34208 16.7249 9.375 16.6454 9.375 16.5625V9.37501H3.125V6.87501H9.375V9.37501H10.625V6.87501H16.875V9.37501H10.625V16.5625C10.625 16.6454 10.6579 16.7249 10.7165 16.7835C10.7751 16.8421 10.8546 16.875 10.9375 16.875H15.625C15.9565 16.875 16.2745 16.7433 16.5089 16.5089C16.7433 16.2745 16.875 15.9565 16.875 15.625V10.625C17.2065 10.625 17.5245 10.4933 17.7589 10.2589C17.9933 10.0245 18.125 9.70653 18.125 9.37501V6.87501C18.125 6.54349 17.9933 6.22554 17.7589 5.99112C17.5245 5.7567 17.2065 5.62501 16.875 5.62501ZM6.60234 4.60938C6.49306 4.51042 6.40542 4.38994 6.34492 4.2555C6.28442 4.12105 6.25237 3.97555 6.25078 3.82813C6.24683 3.6554 6.27739 3.48362 6.34068 3.32285C6.40396 3.16208 6.4987 3.01555 6.61933 2.89186C6.73997 2.76817 6.88408 2.6698 7.04321 2.60251C7.20235 2.53523 7.37332 2.50038 7.54609 2.50001H7.58438C7.7318 2.5016 7.87729 2.53365 8.01174 2.59415C8.14618 2.65465 8.26667 2.74229 8.36563 2.85157C9.02109 3.59219 9.25234 4.82032 9.33359 5.57969C8.57109 5.49923 7.34375 5.26798 6.60234 4.60938ZM13.3992 4.60938C12.6578 5.26563 11.4273 5.49688 10.6648 5.57813C10.7578 4.75704 11.0156 3.55469 11.6406 2.85235C11.7396 2.74307 11.8601 2.65543 11.9945 2.59493C12.129 2.53443 12.2745 2.50238 12.4219 2.50079H12.4602C12.6329 2.50187 12.8038 2.53743 12.9626 2.60538C13.1215 2.67333 13.2652 2.7723 13.3854 2.8965C13.5055 3.02071 13.5996 3.16764 13.6622 3.32868C13.7248 3.48973 13.7547 3.66165 13.75 3.83438C13.7475 3.9808 13.7149 4.12514 13.6543 4.25845C13.5937 4.39176 13.5063 4.51121 13.3977 4.60938H13.3992Z" fill="#4A4A4A"></path>
      </svg>
    </div>
  `;
}

// adjust upsell price title for alternate currencies
waitForElement('#slidecarthq')
  .then(cart => {
    // initial icon replacement
    replaceGiftTierIcon(cart);

    // Re-run icon replacement whenever the progress bar is (re)rendered
    observeSelector('#slidecarthq [data-testid="TieredRewardsProgressBar"]', () => {
      replaceGiftTierIcon(cart);
    });

    // hide second application item of auto-discount TINMEUP
    observeSelector('.slidecarthq .item .discount-allocations', cart_discounts => {
      const text = (cart_discounts.innerText || "").toUpperCase();

      // Existing TINMEUP handling
      if (text.indexOf("TINMEUP") > -1) {
        cart_discounts.classList.add("js-discount-code--TINMEUP");
      }

      // NEW: show purchase requirement note only for CHARMEDTOMEETYOU
      if (
        text.indexOf("CHARMEDTOMEETYOU") > -1 &&
        !cart_discounts.querySelector(".js-charm-30-note")
      ) {
        const codeEl =
          cart_discounts.querySelector(".discount-allocations-flex-1") ||
          cart_discounts;

        const note = document.createElement("div");
        note.className = "js-charm-30-note";
        note.textContent = "$30 purchase required";

        codeEl.appendChild(note);
      }

      // NEW: Mystery Wooble – hide discount icon on cart line
      const mainTopLeft = cart_discounts.closest(".main-top-left");
      if (mainTopLeft) {
        const titleLink = mainTopLeft.querySelector(".title a");

        if (
          titleLink &&
          titleLink.textContent.trim().toLowerCase() === "mystery exclusive wooble"
        ) {
          const iconWrapper = cart_discounts.querySelector(
            ".discount-allocations-flex-initial"
          );
          const iconSvg = cart_discounts.querySelector(
            ".discount-allocations-tags-icon"
          );

          if (iconWrapper) {
            iconWrapper.style.display = "none";
          }
          if (iconSvg) {
            iconSvg.style.display = "none";
          }
        }
      }
    });

    // NEW: Mystery Wooble note on upsell tile (before add-to-cart)
    observeSelector('.slidecarthq .custom-upsell__content', upsell => {
      const titleEl = upsell.querySelector('.custom-upsell__title');
      if (
        !titleEl ||
        titleEl.textContent.trim().toLowerCase() !== 'mystery exclusive wooble' ||
        upsell.querySelector('.js-mystery-wooble-note')
      ) {
        return;
      }

      const note = document.createElement('div');
      note.className = 'js-mystery-wooble-note mystery-wooble-note';
      note.textContent = 'A random exclusive kit';

      titleEl.insertAdjacentElement('afterend', note);
    });

    // Insert Upsells section title
      observeSelector('#slidecarthq .upsells-stacked-container[data-testid="Aupsells"] .upsells-stacked', stack => {
        if (stack.querySelector('.js-upsells-title')) return;

        const title = document.createElement('div');
        title.className = 'js-upsells-title upsells-title';
        title.textContent = "Too fluffin' cute to miss";

        stack.insertAdjacentElement('afterbegin', title);
      });

      // Inject 3-column trust row under checkout button (with SVG checkmarks)
      observeSelector('#slidecarthq footer.footer.sticky-footer', footer => {
        if (footer.querySelector('.js-footer-trust-row')) return;

        const form = footer.querySelector('#slidecart-checkout-form');
        if (!form) return;

        const CHECK_SVG = `
          <svg class="footer-trust-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
            <path d="M7.7 13.7 3.8 9.8a1 1 0 0 0-1.4 1.4l4.6 4.6a1 1 0 0 0 1.4 0l9-9a1 1 0 1 0-1.4-1.4l-8.3 8.3Z"/>
          </svg>
        `;

        const row = document.createElement('div');
        row.className = 'js-footer-trust-row footer-trust-row';
        row.innerHTML = `
          <div class="footer-trust-col">
            ${CHECK_SVG}
            <span class="footer-trust-text">4.7 Stars,<br>17k+ Reviews</span>
          </div>
          <div class="footer-trust-col">
            ${CHECK_SVG}
            <span class="footer-trust-text">24/7<br>Crochet Help</span>
          </div>
          <div class="footer-trust-col">
            ${CHECK_SVG}
            <span class="footer-trust-text">Shipped out<br>of the USA</span>
          </div>
        `;

        form.insertAdjacentElement('afterend', row);
      });

      // Add "Unlocked!" above the custom upsell title (once)
      observeSelector('#slidecarthq .custom-upsell__content', upsell => {
        const titleEl = upsell.querySelector('.custom-upsell__title');
        if (!titleEl) return;

        // only for Mystery Wooble tile (adjust/remove if you want it for all)
        if (titleEl.textContent.trim().toLowerCase() !== 'mystery wooble') return;

        // avoid duplicates
        if (upsell.querySelector('.js-unlocked-label')) return;

        const unlocked = document.createElement('div');
        unlocked.className = 'js-unlocked-label unlocked-label';
        unlocked.textContent = 'Unlocked!';

        titleEl.insertAdjacentElement('beforebegin', unlocked);
      });

    // Locale-specific upsell banner copy
    if (window.location.href.indexOf("en-ca") > -1) {
      document.documentElement.classList.add("js-en-ca");
      cart.insertAdjacentHTML(
        "beforebegin",
        `<style>#slidecarthq #js-upsell-slider-clone::before{
          content: "Add an Accessory for just $7 CAD" !important;
        }</style>`
      );
    } else if (window.location.href.indexOf("en-au") > -1) {
      document.documentElement.classList.add("js-en-au");
      cart.insertAdjacentHTML(
        "beforebegin",
        `<style>#slidecarthq #js-upsell-slider-clone::before{
          content: "Add an Accessory for just $8 AUD" !important;
        }</style>`
      );
    } else if (window.location.href.indexOf("en-gb") > -1) {
      document.documentElement.classList.add("js-en-gb", "lang-en-gb");
      cart.insertAdjacentHTML(
        "beforebegin",
        `<style>#slidecarthq #js-upsell-slider-clone::before{
          content: "Add an Accessory for just £5!" !important;
        }</style>`
      );
    }
  })
  .catch(err => {
    console.error("Error setting up slidecart upsell script", err);
  });



const update_proteus_mini_gallery = (img_url, gallery_id) => {
  if(gallery_id){
    document.querySelector(`.proteus-mini-gallery[data-gallery-id="${gallery_id}"]`).src = img_url;
  } else {
    document.querySelector('.proteus-mini-gallery').src = img_url;
  }
};

// if(getParam("auto-discount")){
//   window.sessionStorage.setItem("auto-discount", getParam("auto-discount"))
// }

// if(getParam("discount")){
//   window.sessionStorage.setItem("auto-discount", getParam("discount"))
// }

// if(getParam("auto-discount") || getParam("discount") || window.sessionStorage.getItem("auto-discount")){
//   // mini cart
//   observeSelector('[name="checkout"]', checkout_btn => {
//     checkout_btn.insertAdjacentHTML("afterend", `
//       <a href="/checkout?discount=${window.sessionStorage.getItem("auto-discount")}" class="button full" style="
//         display: inline-block;
//         vertical-align: middle;
//         color: #fff;
//         background-color: #000;
//         padding: 0 25px;
//         font-weight: 600;
//         line-height: 52px;
//       ">Checkout</a>
//     `);
//     checkout_btn.classList.add("js-hidden");
//   });

//   if(window.sessionStorage.getItem("auto-discount") == "WOOBLES10"){
    
//     observeSelector('#slidecarthq .slidecart-subtotal', cart_subtotal => {
    
//       const update_savings_subtotal = (subtotal_innerText) => {
//         let subtotal_html = `<s style="font-size: .85em; text-decoration: line-through; opacity: .8;">$${parseFloat(subtotal_innerText.replace("$", "")).toFixed(2)}</s> $${parseFloat(subtotal_innerText.replace("$", "")* .9).toFixed(2)}`;
    
//         if(document.querySelectorAll("strong.js-subtotal").length == 0){
//           cart_subtotal.insertAdjacentHTML("afterend", `<strong class="js-subtotal">${subtotal_html}</strong>`);
//         } else {
//           waitForElement("strong.js-subtotal").then(js_subtotal => {
//             js_subtotal.innerHTML = subtotal_html;
//           }).catch();
//         }
//       };
    
//       cart_subtotal.classList.add("js-hidden");
//       update_savings_subtotal(cart_subtotal.innerText);
    
//       const innerText_observer = new MutationObserver(function(mutationsList) {
//         for (let mutation of mutationsList) {
//           if (mutation.type === 'childList' && mutation.target === cart_subtotal) {
    
//             const new_InnerText = cart_subtotal.innerText;
    
//             console.log(cart_subtotal.innerText);
    
//             cart_subtotal.classList.add("js-hidden");
//             let cart_subtotal_price = parseFloat(new_InnerText.replace("$", "")).toFixed(2);
//             update_savings_subtotal(new_InnerText);
    
//           }
//         }
//       });
    
//       const observerConfig = { childList: true, subtree: true };
//       innerText_observer.observe(cart_subtotal, observerConfig);

//     });
    
//   }
  
// }

// --------------------------------------------
// Simple auto-discount capture + SlideCart checkout redirect
// - Keeps WOOBLES10 (and any other code)
// - Captures from:
//   1) ?discount=CODE or ?auto-discount=CODE
//   2) /discount/CODE?redirect=...
// - Persists via sessionStorage
// - Works after AMP re-render (delegated click)
// - No DOM injection, no observers, no polling
// --------------------------------------------

(() => {
  const STORAGE_KEY = "auto-discount";

  const setCode = (code) => {
    if (!code) return;
    sessionStorage.setItem(STORAGE_KEY, String(code));
  };

  const getCode = () => sessionStorage.getItem(STORAGE_KEY);

  // Capture from query params
  try {
    if (typeof getParam === "function") {
      const auto = getParam("auto-discount");
      const disc = getParam("discount");
      if (auto) setCode(auto);
      if (disc) setCode(disc);
    }
  } catch (_) {}

  // Capture from /discount/CODE path
  try {
    const m = window.location.pathname.match(/^\/discount\/([^\/]+)/);
    if (m && m[1]) setCode(decodeURIComponent(m[1]));
  } catch (_) {}

  // Intercept SlideCart checkout click (survives re-render)
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target?.closest?.(
        '#slidecarthq form#slidecart-checkout-form button[name="checkout"]'
      );
      if (!btn) return;

      const code = getCode();
      if (!code) return; // no code -> let normal behavior happen

      e.preventDefault();
      e.stopPropagation();
      window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
    },
    true
  );
})();

/*
START V0 GLOBAL STUFF
*/

if(!window.sessionStorage.getItem("view-hidden-products")){
  for(let i = 0; i < window.hidden_products.length; i++){

    // redirect all hidden-item PDP traffic and hide throughout site
    if(window.location.href.indexOf(window.hidden_products[i].handle) > -1 || window.location.href.indexOf(encodeURIComponent(window.hidden_products[i].handle)) > -1){
      window.location.href = "/";
    }

    // hide from being browsable
    observeSelector(`[href*="${window.hidden_products[i].handle}"]`, hidden_item => {
      
      if(!!hidden_item.closest(".grid__item")){
        hidden_item.closest(".grid__item").remove();
      }
    
      if(!!hidden_item.closest('.predictive-search-item')){
        hidden_item.closest('.predictive-search-item').remove();
      }
    
      if(!!hidden_item.closest('.product-card--list')){
        if(!!hidden_item.closest('li.list-view-item')){
          hidden_item.closest('li.list-view-item').remove()
        } else {
          hidden_item.closest('.product-card--list').remove();
        }
      }
  
    });
  
    // if the gws item IS in their cart, disable QTY selectors (/cart)
    observeSelector(`tr[data-cart-item-url*="${window.hidden_products[i].var_id}"] .cart__qty input`, gwp_item_qty => {
      gwp_item_qty.disabled = true;
    });

    // if the gws item IS in their cart, disable QTY selectors (ajax cart)
    observeSelector(`.items [data-variant-id="${window.hidden_products[i].var_id}"] .quantity-selector button`, gwp_qty_btn => {
      gwp_qty_btn.remove();
    });

    observeSelector(`.items [data-variant-id="${window.hidden_products[i].var_id}"] .quantity-selector input`, gwp_qty_input => {
      gwp_qty_input.disabled = true;
      gwp_qty_input.classList.add("js-disabled-qty");
    });
  
  }
}

if(getParam("view-hidden-products") == "true"){
  window.sessionStorage.setItem("view-hidden-products", true);
}

/*
[WBLS-GLOBAL] Klaviyo Popup Forms
v1: [WBLS - 01] v1: 10s delay (popup iterations)
v1: [WBLS - 08] SMS Capture on Popup

Klaviyo IDs:
- form[data-testid="klaviyo-form-VAUDKQ"] = OG desktop
- form[data-testid="klaviyo-form-XNuNZh"] = OG mobile
- form[data-testid="klaviyo-form-Tgp9x6"] = SMS desktop
- form[data-testid="klaviyo-form-VRexGX"] = SMS mobile

- form[data-testid="klaviyo-form-RB8NA5"] = BT21 Confirmation
- form[data-testid="klaviyo-form-V3s8yq"] = BT21 Capture mobile
- form[data-testid="klaviyo-form-YbP7YP"] = BT21 Capture desktop
*/

waitForElement('body:not(.template-sms-signup)').then(doc => {

  let exp_id = "WBLS-GLOBAL";
  let version_num = "0.07";
  console.log(`init [${exp_id}] -- ${version_num}`);

  // base form handling + helper functions

  if(window.sessionStorage.getItem("js-popup-dismissed")){
    document.documentElement.classList.add("js-popup-disabled");
  }

  observeSelector('[class*="kl-"] [aria-label="POPUP Form"]', popup_container => {
    setTimeout(() => {

      popup_container.insertAdjacentHTML("afterbegin", `
        <div id="js-close-modal">&times;</div>
      `);

      popup_container.querySelector('#js-close-modal').addEventListener("click", () => {
        document.documentElement.classList.add("js-popup-disabled");
        window.sessionStorage.setItem("js-popup-dismissed", true);
      });

    }, 500);
  });

  const select_topmost_ancestor = (element, selector) => {
    if (!element) {
      return null;
    }

    // Check if the current element matches the specified selector
    if (!!element.closest(selector)) {
      // check its parent element recursively
      return select_topmost_ancestor(element.parentElement, selector);
    } else {
      // If it does not match, return the current element
      return element;
    }
  };

  const open_form = (form_id) => {

    if(form_id.split("--").length > 1){

      if(window.innerWidth > 768){
        // desktop
        form_id = form_id.split("--")[0];  
      } else {
        //mobile
        form_id = form_id.split("--")[1];   
      }

    }

    // instantly launch popup of form ID in param
    console.log("open_form()", form_id);

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', form_id]);

    observeSelector(`form[data-testid="klaviyo-form-${form_id}"]`, instant_form => {
      let popup_container = select_topmost_ancestor(instant_form, 'div[class*="kl-"]');
      popup_container.classList.add("js-klaviyo-popup--instant-form");
      console.log("identifying...", instant_form.classList.value)
      setTimeout(() => {
        document.documentElement.classList.remove("js-popup-disabled");
        document.documentElement.classList.add("js-popup-enabled");
      }, 100);

      // remove/disable/block all other would-be popups
      waitUntil(() => {
        return document.querySelectorAll('[class*="js-klaviyo-popup--"]:not(.js-klaviyo-popup--instant-form)').length > 0;
      }).then(() => {
        observeSelector('[class*="js-klaviyo-popup--"]:not(.js-klaviyo-popup--instant-form)', other_form => {
          console.log("removing...", other_form.classList.value)
          other_form.remove();
        });
      }).catch();
      
    });

  };

  observeSelector('[href*="#open="]', form_activator => {
    
    let form_id = form_activator.href.split("#open=")[1];
    form_activator.addEventListener("click", (e) => {
      
      e.preventDefault();
      open_form(form_id);        

    });

  });

  if(getParam("welcome")){
   
    open_form(getParam("welcome"));

  }

  // map each popup as they come into existance

  observeSelector('form[data-testid*="klaviyo-form-"]', all_forms => {
    let popup_container = select_topmost_ancestor(all_forms, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--all"); 
  });

  observeSelector('form[data-testid="klaviyo-form-VAUDKQ"]', og_desktop => {
    let popup_container = select_topmost_ancestor(og_desktop, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--og-desktop");
  });

  observeSelector('form[data-testid="klaviyo-form-XNuNZh"]', og_mobile => {
    let popup_container = select_topmost_ancestor(og_mobile, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--og-mobile");
  });

  observeSelector('form[data-testid="klaviyo-form-Tgp9x6"]', sms_desktop => {
    let popup_container = select_topmost_ancestor(sms_desktop, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--sms-desktop");
  });

  observeSelector('form[data-testid="klaviyo-form-VRexGX"]', sms_mobile => {
    let popup_container = select_topmost_ancestor(sms_mobile, 'div[class*="kl-"]')
    popup_container.classList.add("js-klaviyo-popup--sms-mobile");
  });

  // reveal at 10s
  setTimeout(() => {
    document.documentElement.classList.add("js-popup-enabled");
  }, 10000);

}).catch();


// [WBLS-18] v1 personalization
// CSS exists in proteus-styles.css
if(window.location.href.indexOf("/collections/") > -1 && window.location.href.indexOf("/products/") == -1 ){
  document.documentElement.classList.add("js-wbls18-v1");
}

/* ---------------------
WINNING PERSONALIZATIONS
--------------------- */

// [WBLS - 03] nav with images
(() => {
  
  /*
  v1: big tiles/same org
  */
  
  let exp_id = "WBLS-03";
  let exp_var = "v1";
  console.log(`init [${exp_id}] -- 0.05 -- ${exp_var}`);
  
  // rearrange icon links
  waitForElement('button.site-header__menu').then(header_menu => {
    waitForElement('button.site-header__search-toggle').then(search_toggle => {
      search_toggle.insertAdjacentElement("beforebegin", header_menu);
    }).catch();
  }).catch();
  
  // detect mobile nav open
  setInterval(() => {
      if(document.querySelectorAll('.js-mobile-nav-toggle.mobile-nav--close').length > 0) {
          document.documentElement.classList.add("js-mobile-nav-open");
      } else {
          document.documentElement.classList.remove("js-mobile-nav-open");
      }
  
  }, 100);
  
})(); // WBLS-03

/*
[WBLS-71] PDP Landing Paid Content on Meta Traffic
100% v1 - implementation
*/
// Check if "fbclid" is in the URL
if (window.location.href.indexOf('fbclid') !== -1) {
    // Set the session-long local storage variable
    sessionStorage.setItem('fbclid_present', 'true');
}

// Check if the session-long local storage variable is set
if (sessionStorage.getItem('fbclid_present')) {
    // Create a <style> element
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
        #shopify-section-template--16157272440998__image_with_text_collage_EdLCiy {
            display: block!important;
        }
        #shopify-section-template--16157272440998__compare_grid_h6nge8 {
            display: block!important;
        }
    `;
    // Append the <style> element to the <head>
    document.head.appendChild(style);
}

// WBLS-94 implementation
/*
window.js_cart_incentives = [{
        threshold_USD: 5000,
        message: "FREE SHIPPING",
        label: "free shipping<br>(U.S. only)",
        var_id: "none"
    }, {
        threshold_USD: 10000,
        message: "a FREE ACCESSORY",
        label: `<span class="new-accessory-flag">exclusive  </span>mystery accessory`,
        var_id: 45779459932326
    }];

    window.build_qualifying_items();

    waitForElement('.js-cart').then(() => {
        document.querySelector('.js-cart').remove();
        document.querySelector('.js-cart--overlay').remove();
        js_cart_init();
    }).catch();  
*/ 
// END WBLS-94 implementation

// START [WBLS-97] implementation
let base_cart_incentive = [{
    threshold_USD: 5000,
    message: "FREE SHIPPING",
    label: "free shipping<br>(U.S. only)",
    var_id: "none"
}];

waitForElement('.js-cart').then(cart => {
    document.body.insertAdjacentHTML("afterbegin", `
    <style>
    .js-hide--progress-bar .js-cart--progress-bar{
        display: none !important;
    }
    </style>
    `);
    document.body.classList.add("js-hide--progress-bar");
}).catch();

observeSelector('.js-cart--line-item[data-line-total]', actual_line_item => {
    if(!window.sessionStorage.getItem("[WBLS-97] item added")){
        window.sessionStorage.setItem("[WBLS-97] item added", true);
        let is_100_plus = parseInt(actual_line_item.getAttribute("data-line-total")) > 12500;
        window.sessionStorage.setItem("[WBLS-97] first item is $100+", is_100_plus)
    }
    if(window.sessionStorage.getItem("[WBLS-97] first item is $100+") == "true"){
    
        if(window.js_cart_incentives !== base_cart_incentive){

            window.js_cart_incentives = base_cart_incentive;

            window.build_qualifying_items();

            waitForElement('.js-cart').then(() => {
                document.querySelector('.js-cart').remove();
                document.querySelector('.js-cart--overlay').remove();
                js_cart_init();
            }).catch();  

        }
    } else {
        document.body.classList.remove("js-hide--progress-bar");
    }
});
// END [WBLS-97] implementation

// START [WBLS-95] implementation
observeSelector(".js-cart--line-item", line_item => {

    // build [WBLS-95] items
    for(let i = 0; i < window.wbls95_upsell_items_data.length; i++){
      
        if(document.querySelectorAll(`.js-cart--line-item[data-var-id="${window.wbls95_upsell_items_data[i].associated_product}"]`).length > 0 && 
        document.querySelectorAll(`[data-upsell-item="${window.wbls95_upsell_items_data[i].var_id}"]`).length == 0){

            // associated product exists AND upsell product DOES NOT exist
            // add upsell offer

            let upsell_price = `$${(window.wbls95_upsell_items_data[i].price) / 100}`;

            if(window.wbls95_upsell_items_data[i].price >= 700){
                upsell_price = `<s>${window.wbls95_upsell_items_data[i].price_w_currency.split(" ")[0]}</s> $${(window.wbls95_upsell_items_data[i].price - 200) / 100}`;
            }
            
            document.querySelector(`.js-cart--line-item[data-var-id="${window.wbls95_upsell_items_data[i].associated_product}"]`).insertAdjacentHTML("afterend", `
            
                <div data-upsell-item="${window.wbls95_upsell_items_data[i].var_id}" style="background: #eeeeee; padding: .5rem; margin-top: -.5rem;">
                    <div class="js-row">
        
                    <div class="js-col js-cart--line-item--image">
                        <img src="${window.wbls95_upsell_items_data[i].img_url}">
                    </div>
        
                    <div class="js-col js-cart--line-item--content">
        
                        <div class="js-cart--line-item--details">
                        ${window.wbls95_upsell_items_data[i].title}
                        </div>
        
                        <div class="js-row js-cart--line-item--totals">
                        <div class="js-col--50 js-cart--line-item--quantity">
                        
                            <a data-exp-id="WBLS-95" data-product-requirement="${window.wbls95_upsell_items_data[i].associated_product}"
                            class="js-cart--upsell-item--atc js-cart--button" data-js-atc="${window.wbls95_upsell_items_data[i].var_id}" style="display: inline-block; min-width: 77px; text-align: center;">
                            Add
                            </a>
                        
                        </div>
                        <div class="js-col--50 js-cart--line-item--price">
                            ${upsell_price}
                            <div class="js-cart--line-item--discount"></div>
                        </div>
                        </div>
        
                    </div>
        
                    </div>
                </div>
            
            `);
        } else if(document.querySelectorAll(`[data-upsell-item="${window.wbls95_upsell_items_data[i].var_id}"]`).length > 0){ 
            // upsell offer exists

            setTimeout(() => {
                if(document.querySelectorAll(`.js-cart--line-item[data-var-id="${window.wbls95_upsell_items_data[i].associated_product}"]`).length == 0 ||
                document.querySelectorAll(`.js-cart--line-item[data-var-id="${window.wbls95_upsell_items_data[i].var_id}"]`).length > 0){
                    // associated product does not exist OR upsell product DOES exist
                    document.querySelector(`[data-upsell-item="${window.wbls95_upsell_items_data[i].var_id}"]`).remove();
                }
            }, 200);
            
        }
    }

});

observeSelector('.js-cart--upsell-item--atc[data-js-atc][data-exp-id="WBLS-95"]', js_atc => {
    js_atc.addEventListener("click", () => {
        add_to_cart(js_atc.getAttribute("data-js-atc"), 1, { 
            _promo: "perfect accessory" ,
            _promo_requirement: js_atc.getAttribute("data-product-requirement")
        });
    })
});
// END [WBLS-95] implementation

// ===========================================
// WBLS-93 – In-cart upsells (Mystery Wooble + Holiday Gift Bags)
// ===========================================
// WBLS-93 implementation v2 – support multiple in-cart upsells

const inCartUpsells = (() => {
  const upsells = [];

  // First in-cart upsell – gets holiday promo
  if (window.show_in_cart_upsell) {
    upsells.push({
      key: "1",
      varId: String(window.in_cart_upsell_var_id),
      img: window.in_cart_upsell_img,
      title: window.in_cart_upsell_title,
      price: Number(window.in_cart_upsell_price),
      promo: true, // ✅ holiday promo
    });
  }

  // Second in-cart upsell – NO holiday promo
  if (window.show_in_cart_upsell_2) {
    upsells.push({
      key: "2",
      varId: String(window.in_cart_upsell_var_id_2),
      img: window.in_cart_upsell_img_2,
      title: window.in_cart_upsell_title_2,
      price: Number(window.in_cart_upsell_price_2),
      promo: false, // ❌ no holiday promo
    });
  }

  return upsells;
})();

observeSelector(".js-cart--line-item", () => {
  const lineItemsContainer = document.querySelector(".js-cart--line-items");
  if (!lineItemsContainer || !inCartUpsells.length) return;

  const cartText = lineItemsContainer.innerText.toLowerCase();

  console.log('hit OBSERVE SELECTOR for in cart upsells', inCartUpsells)

  inCartUpsells.forEach((u) => {
    const alreadyInCart = cartText.indexOf(u.title.toLowerCase()) !== -1;
    const existingUpsellEl = document.querySelector(
      `.js-holiday-upsell[data-upsell-key="${u.key}"]`
    );

    if (!alreadyInCart && !existingUpsellEl) {
      // Insert this upsell block
      lineItemsContainer.insertAdjacentHTML(
        "beforebegin",
        `
        <div class="js-holiday-upsell" data-upsell-key="${u.key}" style="background: #eeeeee; padding: .5rem;">
          <div class="js-row">
            <div class="js-col js-cart--line-item--image js-holiday-upsell--image">
              <img src="${u.img}" />
            </div>

            <div class="js-col js-cart--line-item--content">
              <div class="js-cart--line-item--details">
                ${u.title}
              </div>

              <div class="js-row js-cart--line-item--totals">
                <div class="js-col--50 js-cart--line-item--quantity">
                  <a 
                    class="js-cart--upsell-item--atc js-cart--button" 
                    data-js-atc="${u.varId}" 
                    ${u.promo ? 'data-exp-id="WBLS-93"' : ''} 
                    style="display: inline-block; min-width: 77px; text-align: center;"
                  >
                    Add
                  </a>
                </div>
                <div class="js-col--50 js-cart--line-item--price">
                  <s>$${u.price}</s> $${(u.price * 0.9).toFixed(0)}
                  <div class="js-cart--line-item--discount"></div>
                </div>
              </div>

            </div>
          </div>
        </div>
        `
      );
    } else if (alreadyInCart && existingUpsellEl) {
      // If they added that upsell, remove its banner
      existingUpsellEl.remove();
    }
  });
});

// .js-holiday-upsell - DISABLED for new GWP 
// observeSelector(
//   '.js-cart--upsell-item--atc[data-js-atc][data-exp-id="WBLS-93"]',
//   (js_atc) => {
//     js_atc.addEventListener("click", () => {
//       add_to_cart(js_atc.getAttribute("data-js-atc"), 1, {
//         _promo: "holiday 10% off",
//       });
//     });
//   }
// );

// 🔹 New: non-promo upsell handler (no _promo, no discount)
observeSelector(
  '.js-cart--upsell-item--atc[data-js-atc]:not([data-exp-id="WBLS-93"])',
  (js_atc) => {
    js_atc.addEventListener("click", () => {
      add_to_cart(js_atc.getAttribute("data-js-atc"), 1);
    });
  }
);

// END [WBLS-93] implementation

// BFCM 25 CART TREATMENTS
